// IMPORTAR LOS MODULOS NECESARIOS PARA LAS FUNCIONES.

import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder, NativeGeocoderResult, NativeGeocoderOptions } from '@ionic-native/native-geocoder/ngx';
import { Router } from '@angular/router';
import { Globals } from '../globals';
import { AdressPage } from '../adress/adress.page';
import { RegisterPage } from '../register/register.page';

declare var google: any;


@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})



export class MapComponent implements OnInit {

  @ViewChild('map',  {static: false}) mapElement: ElementRef;
  map: any;
  address: string;
  lat: string;
  long: string;
  autocomplete: { input: string; };
  autocompleteItems: any[];
  location: any;
  placeid: any;
  GoogleAutocomplete: any;
  direcciones: any[];
  actual: string;

  constructor(
    private geolocation: Geolocation,
    private nativeGeocoder: NativeGeocoder,
    public zone: NgZone,
    private route: Router,
    public global: Globals,
    public form: AdressPage,

  ){
    this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
    this.autocomplete = { input: '' };
    this.autocompleteItems = [];
  }

  // CARGAMOS EL MAPA EN ONINIT
  ngOnInit() {
    this.loadMap();

  }
  actualDireccion(){
    const url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + this.lat + ',' + this.long + '&key=AIzaSyAaRRiNeQc1xLWeLLhohM7JX6Ti8Si38vs';
    fetch(url)
    .then((response) => response.json())
    .then((responseJson) => {
      const txt = document.getElementById('address') as HTMLInputElement;
      const zip = document.getElementById('cp') as HTMLInputElement;
      const number = document.getElementById('number') as HTMLInputElement;
      txt.value = responseJson.results[0].formatted_address;

      responseJson.results[0].address_components.filter((numero) => {
        if (numero.types[0] == 'street_number'){
          number.value = numero.long_name
        }
      });

      this.global.nombreCalle = txt.value;
      zip.value = responseJson.results[0].address_components[responseJson.results[0].address_components.length - 1].long_name;
      this.global.lat = responseJson.results[0].geometry.location.lat;
      this.global.lng = responseJson.results[0].geometry.location.lng;
      this.global.disabled = false;
      this.form.dismiss();
    });
  }


  // CARGAR EL MAPA TIENE DOS PARTES
  loadMap() {
    // OBTENEMOS LAS COORDENADAS DESDE EL TELEFONO.
    this.geolocation.getCurrentPosition().then((resp) => {
      const latLng = new google.maps.LatLng(resp.coords.latitude, resp.coords.longitude);
      const mapOptions = {
        center: latLng,
        zoom: 17,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        fullscreenControl: false,
        cancelable: false,
        zoomControl: false,
        streetViewControl: false
      };

      this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
      this.lat = this.map.center.lat();
      this.long = this.map.center.lng();

      const url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + this.lat + ',' + this.long + '&key=AIzaSyAaRRiNeQc1xLWeLLhohM7JX6Ti8Si38vs';
      fetch(url)
        .then((response) => response.json())
        .then((responseJson) => {
        this.autocomplete.input = responseJson.results[0].address_components[1].long_name;
      });

      // CUANDO TENEMOS LAS COORDENADAS SIMPLEMENTE NECESITAMOS PASAR AL MAPA DE GOOGLE TODOS LOS PARAMETROS.
      this.getAddressFromCoords(resp.coords.latitude, resp.coords.longitude);
      this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
      this.map.addListener('dragend', () => { // dragend es un evento de la api de google maps, el evento se acciona cuando terminas de desplazar el mapa.
        this.lat = this.map.center.lat();
        this.long = this.map.center.lng();
        this.getAddressFromCoords(this.map.center.lat(), this.map.center.lng());
      });

    }).catch((error) => {
      console.log('Error getting location', error);
    });

  }





  getAddressFromCoords(lattitude, longitude) {
    const options: NativeGeocoderOptions = {
      useLocale: true,
      maxResults: 5
    };
    this.nativeGeocoder.reverseGeocode(lattitude, longitude, options)
      .then((result: NativeGeocoderResult[]) => {
        this.address = '';
        const responseAddress = [];
        for (const [key, value] of Object.entries(result[0])) {
          if (value != '') {
          responseAddress.push(value);
          }
        }
        responseAddress.reverse();
        for (const value of responseAddress) {
          this.address += value + ', ';
        }
        this.address = this.address.slice(0, -2);
      })
      .catch((error: any) => {
        this.address = 'Address Not Available!';
      });
  }

}
